//Respuesta a  un link invalido 

//Imports 
import React from 'react';
import {Result} from 'antd';

//Componente a  buscar
class NoActiveLink extends React.Component {
    render() {
        return (
            <Result
                status="warning"
                title="Lo sentimos."
                subTitle="El link ingresado no es válido. Por favor, contacta a tu unidad encargada de generar la invitación."

            />)
    }
}

export default NoActiveLink;